<template>
  <section class="data-cues">

    <DataCuesHeader :title="listData.cardTitle" :image="listData.cardImage" :subTitle="listData.cardSubTitle" :description="listData.cardDescription" />

    <div class="content-wrapper">

      <DataCuesCard v-if="!listData.isExpandableSectionEnabled" :stats="listData.dataliststatsblocks"
        :highlightColor="listData.cardHighlightColor" :title="listData.inlineCardTitle"
      />

      <div v-else class="data-cues__slider" :class="{ 'center-cards': cardCount === 1 || cardCount === 2 , 'single-card': cardCount === 1 }">
        <VueSlickCarousel
          v-bind="settings"
          ref="carousel"
          @init="handleInit"
          @afterChange="handleAfterChange"
        >         
          <div v-for="(card, i) in listData.expandabledatalists" :key="i" class="data-cues__slide">
            <DataCuesCard :title="card.expandableCardTitle" :stats="card.expandableDataliststatsblocks" :highlightColor="listData.cardHighlightColor" />
          </div>
          <template #prevArrow>
            <button type="button" class="slick-prev" :aria-label="previousButtonLabel">
              <span class="sr-only">{{ previousButtonLabel }}</span>
            </button>
          </template>
          <template #nextArrow>
            <button type="button" class="slick-next" :aria-label="nextButtonLabel">
              <span class="sr-only">{{ nextButtonLabel }}</span>
            </button>
          </template>
        </VueSlickCarousel>
      </div>
    </div>
    <DataCuesFooter :sources="listData.sources" :links="listData.links" :footNoteText="listData.footNoteText" :learnMoreText="listData.learnMoreText" :learnMoreLink="listData.learnMoreLink" :isExternalLink="listData.isExternalLink" :learnMoreTaggingAttributes="listData.learnMoreTaggingAttributes" />
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'; 
import DataCuesCard from './DataCuesCard.vue'
import DataCuesHeader from './DataCuesHeader.vue'
import DataCuesFooter from './DataCuesFooter.vue'

export default {
  name: 'DataCuesList',
  components: {
    DataCuesCard,
    VueSlickCarousel,
    DataCuesHeader,
    DataCuesFooter
  },
  props: {
    listData: {
      type: Object,
      required: true
    }
  }, 
  data() {
    return {
      currentSlide: 0,
    };
  },
  computed: {
    cardCount() {
      return this.listData.expandabledatalists?.length || 0;
    },   
    previousButtonLabel() {
      return `Previous information - ${this.listData.cardTitle}`;
    },
    nextButtonLabel() {
      return `Next information - ${this.listData.cardTitle}`;
    },
    settings() {
      return {
        'dots': false,
        'arrows': true,
        'infinite': false,
        'speed': 500,
        'slidesToShow': 3,
        'swipe': true,
        'draggable': true,
        'slidesToScroll': 1,
        'initialSlide': 0,
        'touchThreshold': 5,  
        'lazyLoad':'progressive',
        'variableWidth': true,
        'responsive': [ 
        {
            breakpoint: 1023,
            settings: {  
              dots: true,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,  
              speed: 500,  
              initialSlide:0,   
              touchThreshold:5,
              swipe: true,
              focusOnSelect: true,
              lazyLoad:'progressive',
              variableWidth: true,
            }
          },
          {
            breakpoint: 768,
            settings: { 
              centerMode: false,
              slidesToShow: 1.1,
              slidesToScroll: 1, 
              speed: 500, 
              arrows: false,
              initialSlide: 0,  
              swipe: true,
              touchThreshold: 5,
              dots: true,
              focusOnSelect: true,
              lazyLoad: 'progressive',
              variableWidth: true,
            }
          },
        ]
      };
    }
  },
  methods: {
    handleInit() {
      this.$nextTick(this.updateDotAccessibility);
    },
    handleAfterChange(index = 0) {
      this.currentSlide = index;
      this.$nextTick(this.updateDotAccessibility);
    },
    updateDotAccessibility() {
      const carouselEl = this.$refs.carousel?.$el;
      if (!carouselEl) {
        return;
      }
      const dots = carouselEl.querySelectorAll('.slick-dots li');
      if (!dots || !dots.length) {
        return;
      }
      dots.forEach((dot, idx) => {
        const button = dot.querySelector('button');
        if (!button) {
          return;
        }
        const isActive = dot.classList.contains('slick-active');
        button.setAttribute('aria-current', isActive ? 'true' : 'false');
        const title = this.listData.cardTitle || this.listData.inlineCardTitle || 'data cues carousel';
        const slideLabel = `Slide ${idx + 1} - ${title}`;
        button.setAttribute('aria-label', slideLabel);
        if (!button.textContent || button.textContent !== slideLabel) {
          button.textContent = slideLabel;
        }
      });
    }
  }
}
</script>
<style lang="scss" src="./DataCuesList.scss"></style>


